import React from "react";
import { motion } from "framer-motion";
import "../index.css";
import { Link } from "react-router-dom";

export default function OfferSection() {
  return (
    <section
      className="relative bg-fixed bg-cover bg-center py-20 md:py-28 text-white"
      style={{
        backgroundImage: "url('/images/banner5.webp')",
      }}
    >
      {/* Dark overlay for clarity */}
      <div className="absolute inset-0 bg-black/60"></div>

      <div className="container mx-auto px-6 relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
        {/* Left side — Decorative or empty (can add an image later if you want) */}
        <div className="flex-1"></div>

        {/* Right side — Offer Text */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="flex-1 text-center md:text-left"
        >
          <h3 className="text-3xl sm:text-4xl font-bold leading-snug">
            Best Offers for You!{" "}
            <span className="block text-pink-400 mt-3 font-semibold">
              Get started today!
            </span>
          </h3>
          <p className="text-gray-200 mt-5 max-w-lg">
            Launch your website with powerful hosting and
            expert support — all at unbeatable prices. Build your online
            presence the smart way!
          </p>

          <Link
            to="/domains"
            className="inline-block mt-8 bg-pink-500 hover:bg-pink-600 text-white font-semibold px-8 py-3 rounded-lg transition-all duration-300 shadow-lg"
          >
            Sign Up Now
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
